import { Context } from '@apollo/client';
import { Status } from './customersTabManager';
import { CartItem } from './flowManager';
import { startFsRecording } from './fullStoryManager';
import logger from './loggerManager';
import { tracker } from './trackerManager';
import { CartDetails, ConsumerDetails } from '@chargeafter/payment-sdk';

interface UserSessionData {
  context: Context;
  creditAmount?: number;
  isApprovedAmountEstimated: boolean;
  lenderId: string;
  applicationId: string | undefined;
  consumerDetails: ConsumerDetails;
  cartItems?: CartItem[];
  selectedConsumerStatus: Status | undefined;
  userEmail?: string;
  checkoutMinimumAmount?: number;
  financialProductType?: string;
  advancedCart?: CartDetails;
  switchToAdvancedCart?: boolean;
  merchantOrderId?: string;
  itemName: string;
}

export let userSession: null | UserSessionData = null;

export const getUserSession = () =>
  JSON.parse(sessionStorage.getItem('userSession')!);

const setUserSession = (userSession: UserSessionData) => {
  sessionStorage.setItem('userSession', JSON.stringify(userSession));
};

export const saveToUserSession = <K extends keyof UserSessionData>(
  key: K,
  value: UserSessionData[K],
) => {
  const previousUserSessionData = sessionStorage.getItem('userSession')
    ? getUserSession()
    : null;
  const updatedUserSessionData = {
    ...previousUserSessionData,
    [key]: value,
  };
  setUserSession(updatedUserSessionData);
};

export const clearSavedUserSession = () => {
  sessionStorage.removeItem('userSession');
  userSession = null;
};

export const restoreUserSession = () => {
  userSession = getUserSession();
  if (userSession && userSession.userEmail && userSession.consumerDetails) {
    const consumerIdentificationData =
      userSession.consumerDetails.mobilePhoneNumber ??
      userSession.consumerDetails.id;
    startFsRecording(userSession.userEmail ?? '', consumerIdentificationData);
    tracker.identify(consumerIdentificationData!);
    logger.log('Restored user session from storage', {
      filename: 'userSessionStorageManager.ts',
      function: 'restoreUserSession',
      userEmail: userSession.userEmail,
      userSession,
      context: userSession.context,
    });
  }
};
